import {
  ChatbotValue,
  ChatObject,
} from "../../../services/api/instances/botApi/types";
import {
  botMigrationToStorageObjectReducerBuilder,
  getBotChatsReducerBuilder,
  getBotMessagesReducerBuilder,
  updateChatbotAssistantReducerBuilder,
} from "./reducers";
import type { ChatbotState } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: ChatbotState = {
  chatbotValue: null,
  chats: {},
  messages: [],
  isLoading: false,
  isDisabled: false,
  isMessageLoading: false,
};

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    setChatbotValue: (state, action: PayloadAction<ChatbotValue>) => {
      state.chatbotValue = action.payload;
    },
    setChats: (
      state,
      action: PayloadAction<{ botRef: string; chat: ChatObject[] }>,
    ) => {
      const { botRef, chat } = action.payload;
      if (!state.chats[botRef]) {
        state.chats[botRef] = [];
        return;
      }
      state.chats[botRef] = chat;
    },
    setClearMessages: (state) => {
      state.messages = [];
    },
  },
  extraReducers: (builder) => {
    botMigrationToStorageObjectReducerBuilder(builder);
    updateChatbotAssistantReducerBuilder(builder);
    getBotChatsReducerBuilder(builder);
    getBotMessagesReducerBuilder(builder);
  },
});

export const chatbotReducers = chatbotSlice.reducer;
export const { setChatbotValue, setChats, setClearMessages } =
  chatbotSlice.actions;
